import React from 'react';
import { Handle, Position } from '@xyflow/react';
import './UnitCardNode.css';

class UnitCardNode extends React.Component
{
    state = 
    {
        isSelected: false,
    };

    onMouseEnter = () => {
        this.setState({isSelected: true});
    }

    onMouseLeave = () => {
       this.setState({isSelected: false});
    }

    convertToLink = name => {
        var convertedName = "";

        for (let i = 0; i < name.length; i++)
        {
            var char = name.charAt(i);
            if(char === char.toUpperCase())
                convertedName += "_" + char.toLowerCase();
            else
                convertedName += char;
        }
        
        return convertedName;
    }

    convertToName = name => {
        var convertedName = "";

        for (let i = 0; i < name.length; i++)
        {
            var char = name.charAt(i);
            if(i === 0)
                convertedName += char.toUpperCase();
            else if(char === char.toUpperCase())
                convertedName += " " + char;
            else
                convertedName += char;
        }
        
        return convertedName;
    }

    render()
    {
        const faction = this.props.data.faction.toLowerCase();
        const unitType = this.props.data.unitType;
        const unitLink = this.convertToLink(unitType);
        const unitName = this.convertToName(unitType);
        const wikiUrl = "https://obsidiagon.com/kingdomwars/wiki/doku.php?id=" + faction + "_units#" + unitLink;
        const isSelected = this.state.isSelected;
        const isAvailable = this.props.data.isAvailable;
        const nodeClass = isSelected ? "unit-card-node-selected" : isAvailable ? "unit-card-node" : "unit-card-node-disabled";
        const iconClass = isSelected ? "unit-card-icon-selected" : isAvailable ? "unit-card-icon" : "unit-card-icon-disabled";

        return (
          <>
              <Handle type="source" position={Position.Right} />
              <Handle type="target" position={Position.Left} />
              <div className={nodeClass} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                  <a target="_blank" rel="noopener noreferrer" href={wikiUrl}>
                  <img className={iconClass} src={require('../Resources/' + unitType + '.png')} alt="imageNotFound"/>
                  </a>
                  {isSelected && (<span className='unit-card-title'>{unitName}</span>)}
              </div>
          </>
        );
    }
}

export default UnitCardNode;